import { fCurrency, fNumber } from './formatNumber';

export const normalizeTagsValue = (value) => {
    if (Array.isArray(value)) {
        return value.map((tag) => tag.trim());
    }
    if (typeof value === 'string') {
        return value.split(',').map((tag) => tag.trim());
    }
    return [];
};

const parseLangValue = (value) => {
    try {
        const parsedLang = JSON.parse(value);
        if (typeof parsedLang === 'object' && parsedLang !== null) {
            return (
                parsedLang['en'] ||
                parsedLang['de'] ||
                Object.values(parsedLang)[0] ||
                ''
            );
        }
    } catch (error) {
        console.error('Error parsing language JSON:', error);
        return '';
    }
};

export const getContent = (item, key, type) => {
    if (!item) return '';
    if (!key) return typeof item === 'string' ? item : '';

    let newValue = '';
    if (key.includes('.')) {
        const keys = key.split('.');
        newValue = item[keys[0]]?.[keys[1]] || '';
    } else {
        newValue = item?.[key] || '';
    }

    switch (type) {
    case 'amount':
        return newValue ? fCurrency(newValue) : '';
    case 'number':
        return newValue ? fNumber(newValue) : '';
    case 'canton':
        return newValue ? newValue.name : '';
    case 'lang':
        return parseLangValue(newValue);
    default:
        return newValue;
    }
};
